// extracted by mini-css-extract-plugin
export default {"chip_container":"GeneralChips_chip_container__P-ME2","active":"GeneralChips_active__KmADb"};